import React from 'react';

const TrackingGetstarted =()=>{
    return(
        <section className="tracking_getting_area sec_pad">
            <div className="container wow fadeInUp">
                <img src={require("../img/home-tracking/cta.png")} alt=""/>
                <h2>Try for free now</h2>
                <a href="/#" className="software_banner_btn btn_submit f_500">Get Started</a>
            </div>
        </section>
    )
}

export default TrackingGetstarted;